import { render, staticRenderFns } from "./Form16Table.vue?vue&type=template&id=32b59da8"
import script from "./Form16Table.vue?vue&type=script&lang=ts"
export * from "./Form16Table.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports